import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-gray-50 h-screen" }
const _hoisted_2 = { class: "flex flex-col mt-16" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-5 text-sm text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary" }, "Dashboard")
], -1)
const _hoisted_4 = { class: "space-y-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerComponent = _resolveComponent("headerComponent")!
  const _component_listItemComponent = _resolveComponent("listItemComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_headerComponent),
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          _createVNode(_component_listItemComponent, {
            route: 'bookings',
            title: 'Tur liste',
            subTitle: 'Dine allokerede ture'
          })
        ])
      ])
    ])
  ]))
}